// Shared scoring/banding helpers for the Class Overview dashboard.
// Extracted from ClassOverview so panels don't import from the orchestrator
// (and so SkillHeatmap stops re-declaring its own copy).

import { SCORE_MARK, SCORE_TINT, SCORE_FG } from '../ds';

// Per-score fill colors for the 1–5 scale — re-exported from the single
// source (ScoreChip.tsx) so this module can't drift from it again.
export const SCORE_COLORS = SCORE_MARK;

// Buckets an average score (1–5) into a qualitative band.
//   < 2.5 → low, < 3.5 → mid, else high; null → none (ungraded).
export function scoreBand(score) {
  if (score == null) return 'none';
  if (score < 2.5) return 'low';
  if (score < 3.5) return 'mid';
  return 'high';
}

// Buckets a mastery fraction (0–1) into a qualitative band.
export function masteryBand(pct) {
  if (pct == null) return 'none';
  if (pct < 0.25) return 'low';
  if (pct < 0.5) return 'mid';
  return 'high';
}

// Finer-grained mastery → {bg, fg} colors for mastery chips/cells — the five
// bands map onto the score family's tint/fg pairs, so mastery and score never
// disagree about what "red" means.
export function masteryColors(pct) {
  if (pct == null) return { bg: '#f1f5f9', fg: '#94a3b8' };
  const band = pct < 0.25 ? 1 : pct < 0.5 ? 2 : pct < 0.75 ? 3 : pct < 0.9 ? 4 : 5;
  return { bg: SCORE_TINT[band], fg: SCORE_FG[band] };
}
